import ua from './ua';
import ru from './ru';

export default {
    ua,
    ru
};
